import type { ReactNode } from 'react';
import type { LucideIcon } from 'lucide-react';
import { cn } from '@mlm/ui';

/**
 * The shared empty surface: a quiet bordered card with a muted icon, a plain
 * title, an optional sentence, and an optional action. Stands on its own (not
 * nested in another Card) so it reads as the content, not a placeholder inside
 * content. Used wherever a list or page has nothing to show yet.
 */
export function EmptyState({
  icon: Icon,
  title,
  description,
  action,
  className,
}: {
  icon: LucideIcon;
  title: string;
  description?: ReactNode;
  action?: ReactNode;
  className?: string;
}) {
  return (
    <div className={cn('rounded-lg border bg-card px-6 py-16 text-center', className)}>
      <Icon className="mx-auto h-10 w-10 text-muted-foreground/50" aria-hidden />
      <p className="mt-3 text-sm font-medium">{title}</p>
      {description ? (
        <p className="mx-auto mt-1 max-w-md text-sm text-muted-foreground">{description}</p>
      ) : null}
      {action ? <div className="mt-4 flex justify-center">{action}</div> : null}
    </div>
  );
}
